
const Actor = (props) => {
    const {
        actorType,
        actorName,
        boxNumber,
        actorDetails,
        renderForm
    } = props
    return renderForm ? renderForm({
        actorType:actorType,
        displayEoriNo:actorType!=='buyer',
        boxNumber:boxNumber,
        disabled:true,
        actorName:actorName,
        dataSource:actorDetails,
    }) : null
}

export default Actor